import InvoicingData from 'components/pages/OrderPage/components/InvoicingData';
import useOrderPage from 'components/pages/OrderPage/useOrderPage';
import Button from 'components/ui/Button/Button';
import Checkbox from 'components/ui/Form/controls/Checkbox/Checkbox';
import Form from 'components/ui/Form/Form';
import PageSettings from 'components/ui/PageSettings/PageSettings';
import StepIndicator from 'components/ui/StepIndicator/StepIndicator';
import ConfirmationModal from 'components/ui/ConfirmationModal/ConfirmationModal';
import Logos from 'components/ui/Logos/Logos';
import Logo from 'components/ui/Logo/Logo';
import OrderSummary from 'components/pages/OrderPage/components/OrderSummary';
import SimplePayTerms from 'components/ui/SimplePayTerms/SimplePayTerms';
import SimplePayCardRegistrationTerms from 'components/ui/SimplePayCardRegistrationTerms/SimplePayCardRegistrationTerms';
import OrdersTable from 'components/pages/OrderPage/components/OrdersTable';

const OrderPage = () => {
  const {
    orderData,
    formMethods,
    onsubmit,
    isLoading,
    handleGoBack,
    handleDijb,
    openModalWithContent,
    handleAcceptCheckbox
  } = useOrderPage();

  if (isLoading) {
    return <div>loading</div>;
  }

  if (!orderData) {
    return <div>Order not found</div>;
  }

  const arvalt = orderData.issuer?.startsWith('arvalt') || orderData.issuer?.startsWith('tapertek');
  let cimke = 'Fizetés';
  if (orderData.recurring?.paymentMode === 'RECURRING_START') {
    cimke = 'Kártyaregisztrációs fizetés';
  } else if (!arvalt) {
    cimke = 'Online fizetés';
  }

  return (
    <>
      <PageSettings issuer={orderData.issuer} page="Megrendelés összesítő" />
      <div className="w-full p-8 text-darkBlue-100">
        <div className="flex justify-center mb-8">
          <div className="w-56">
            <Logo issuer={orderData.issuer} />
          </div>
        </div>
        <StepIndicator stepCount={3} currentStep={3} />
        <h2 className="text-2xl lg:text-3xl text-center my-8 font-semibold">
          Megrendelés összesítő
        </h2>
        <section className="pb-4 mb-4">
          <InvoicingData invoicing={orderData.invoicing} />
          <div className="w-full mt-6 border-b-darkBlue-5 border" />
        </section>
        {orderData.cupon ? (
          <section className="pb-4 mb-4">
            <p className="mb-2">
              <span className="font-semibold">Felhasznált kupon: </span>
              <span className="text-darkBlue-60">{orderData.cupon}</span>
            </p>
            <p className="mb-2">
              <span className="font-semibold">Kupon által biztosított kedvezmény: </span>
              <span className={orderData.cuponRate ? 'text-darkBlue-60' : 'text-red-700'}>
                {orderData.cuponRate ? `${orderData.cuponRate}%` : 'Nem érvényes kupon!'}
              </span>
            </p>
            <div className="w-full mt-6 border-b-darkBlue-5 border" />
          </section>
        ) : null}
        <section className="pb-4 mb-4">
          <OrdersTable orderData={orderData} />
        </section>
        <OrderSummary orderData={orderData} />
        <section className="pb-4 mb-4">
          <Form onSubmit={onsubmit} formMethods={formMethods}>
            <div className="flex flex-col justify-start h-36">
              <Checkbox
                name="terms"
                label={
                  <button
                    className="font-semibold text-left"
                    onClick={(e) => {
                      e.preventDefault();
                      openModalWithContent(
                        <ConfirmationModal
                          title="ÁSZF"
                          content={
                            <iframe
                              src="https://www.parola.hu/aszf"
                              className="h-full min-h-[400px] w-full"
                            />
                          }
                          onConfirm={() => handleAcceptCheckbox('terms')}
                          confirmText="Megértettem"
                        />
                      );
                    }}
                  >
                    Elolvastam és elfogadom az ÁSZF-et.
                  </button>
                }
              />
              <Checkbox
                name="privacy"
                label={
                  <button
                    className="font-semibold text-left"
                    onClick={(e) => {
                      e.preventDefault();
                      openModalWithContent(
                        <ConfirmationModal
                          title="Adatkezelési tájékoztató"
                          content={
                            <iframe
                              src="https://www.parola.hu/adatkezeles"
                              className="h-full min-h-[400px] w-full"
                            />
                          }
                          onConfirm={() => handleAcceptCheckbox('privacy')}
                          confirmText="Megértettem"
                        />
                      );
                    }}
                  >
                    Elolvastam és elfogadom az adatkezelési tájékoztatót.
                  </button>
                }
              />
              <Checkbox
                name="simpleTerms"
                label={
                  <button
                    className="font-semibold text-left"
                    onClick={(e) => {
                      e.preventDefault();
                      openModalWithContent(
                        <ConfirmationModal
                          title=""
                          content={
                            <div className="flex-1 flex flex-col overflow-auto">
                              <SimplePayTerms />
                              {orderData.recurring?.paymentMode === 'RECURRING_START' ? (
                                <SimplePayCardRegistrationTerms />
                              ) : null}
                            </div>
                          }
                          onConfirm={() => handleAcceptCheckbox('simpleTerms')}
                          confirmText="Megértettem"
                        />
                      );
                    }}
                  >
                    {orderData.recurring?.paymentMode === 'RECURRING_START'
                      ? 'Elolvastam és elfogadom a SimplePay adattovábbítási és kártyaregisztrációs nyilatkozatot.'
                      : 'Elolvastam és elfogadom a SimplePay adattovábbítási nyilatkozatot.'}
                  </button>
                }
              />
            </div>
            <div className="mt-8">
              <Logos url="https://simplepartner.hu/PaymentService/Fizetesi_tajekoztato.pdf" />
            </div>
            <div className="mt-8">
              <Form.Group className="flex-col lg:flex-row">
                <Button
                  variant="outline"
                  color="lightBlue"
                  className="flex-1 mb-{arvalt ? '4' : '2'}"
                  fullWidth
                  onClick={handleGoBack}
                >
                  Vissza
                </Button>
                {arvalt ? (
                  ''
                ) : (
                  <Button
                    variant="default"
                    color="info"
                    className="flex-1 mb-3"
                    fullWidth
                    onClick={handleDijb}
                  >
                    Utalás - díjbekérőt kérek
                  </Button>
                )}
                <Button
                  type="submit"
                  variant="default"
                  color="lightBlue"
                  className="flex-1"
                  fullWidth
                >
                  {cimke}
                </Button>
              </Form.Group>
            </div>
          </Form>
        </section>
      </div>
    </>
  );
};

export default OrderPage;
